import React, { FC } from "react"

import { Button, ScrollArea, Skeleton, Table } from "@mantine/core"
import { IconPlus, IconUsers } from "@tabler/icons-react"

import SettingsCard from "../settings-card/SettingsCard"
import { useLanguage } from "../../../contexts/language-context"
import { useUsers } from "../../../contexts/users-context"
import { useGroups } from "../../../contexts/devices-context"
import UsersSettingsItem from "./UsersSettingsItem"
import CreateUserModal from "./CreateUserModal"
import { useDisclosure } from "@mantine/hooks"
import { useAuth } from "../../../contexts/authentication-context"

const UsersSettingsCard: FC = () => {
    const { L } = useLanguage()
    const { data: users, loading: usersLoading } = useUsers()
    const { loading: groupsLoading } = useGroups()
    const [opened, { open, close }] = useDisclosure(false)
    const { hasRole } = useAuth()

    return (
        <SettingsCard
            title={L("User access")}
            icon={IconUsers}
            action={hasRole("admin") ? (
                    <Button variant="subtle" leftIcon={<IconPlus size={16} />} onClick={open}>
                        {L("Create user")}
                    </Button>
                ) : undefined
            }
            description={L(
                "Create hierarchical structures by allowing some users to see only particular groups and devices within. Users who may view all groups should be granted full access. Roles can be used to limit what a user can edit.",
            )}
        >
            <ScrollArea>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>{L("Name")}</th>
                            <th style={{ width: "20%" }}>{L("Email address")}</th>
                            <th style={{ width: "30%" }}>{L("Roles")}</th>
                            <th style={{ width: "30%" }}>{L("Groups")}</th>
                            <th style={{ width: "1%" }} />
                        </tr>
                    </thead>
                    <tbody>
                        {groupsLoading || usersLoading
                            ? new Array(5).fill(null).map(_ => (
                                  <tr>
                                      <td style={{ width: "25%" }}>
                                          <Skeleton w="75%" h={16} my={10} />
                                      </td>
                                      <td style={{ width: "25%" }}>
                                          <Skeleton w="75%" h={16} my={10} />
                                      </td>
                                      <td style={{ width: "50%" }}>
                                          <Skeleton w="75%" h={16} my={10} />
                                      </td>
                                      <td />
                                  </tr>
                              ))
                            : users.map(user => <UsersSettingsItem user={user} />)}
                    </tbody>
                </Table>
            </ScrollArea>
            <CreateUserModal opened={opened} onClose={close} />
        </SettingsCard>
    )
}

export default UsersSettingsCard
